/**
 * exports HTTP status codes
 */

const statusCodes = {
  NO_CONTENT: 204,
  OK: 200,
};

module.exports = statusCodes;



// WEBPACK FOOTER //
// ./lib/utils/http_status.js